import store from '../../store/store'

const loadProperties = (to, from) => {
	if ((from.name === 'objetoQuestoes' || from.name === 'objetoDetalhes') && (to.name !== 'objetoEdit' && to.name !== 'objetoCreate')) {
		store.dispatch({ type: 'unloadObjectProps' })
	}

	if ((from.name === 'objetoCreate' || from.name === 'objetoEdit') && (to.name !== 'objetoQuestoes' && to.name !== 'objetoDetalhes')) {
		store.dispatch({ type: 'unloadObjectProps' })
	}
}

export default loadProperties
